import { APIGet } from "../API";
import { RenderIf } from "../helpers/RenderIf";
import React, { useEffect, useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { T } from "../traks";
import { LL } from "./LL";

const stripFinalSlash = (path) => path.slice(-1) === "/" ? path.substring(0, path.length-1) : path

const NavItemLinkSpan = ({ link, children }) => {
  return (
    <NavItem className="ps-3">
      <NavLink href={LL(link)}>
        <span className={(LL(link) === stripFinalSlash(window.location.pathname) ? "nav_selected" : "nav_not_selected")}>
          {children}
        </span>
      </NavLink>
    </NavItem>
  );
}


export const NavBarContent = ({ anonymous, nonanonymous }) => {
  const [loggedIn, setLoggedIn] = useState(false)


  const checkWhoami = () => {
    APIGet("whoami").then(whoami => {
      const emptyBody = Object.keys(whoami.data).length === 0;
      if (!emptyBody) {
        whoami = whoami.data;
        setLoggedIn(true);
      } else {
        whoami = null;
      }
    }).catch(err => {
        console.log(err)
    })
  }

  useEffect(() => {
    checkWhoami()
  }, [])

  if (anonymous) return <div className="txt_orange"><T>Anonymous mode</T></div>;
  if (nonanonymous) return <div className="txt_orange"><T>Confidential mode</T></div>;

  return (<>
    <Nav navbar className='ms-auto'>
      <RenderIf condition={!loggedIn}>
        <NavItem>
          <NavLink href={LL('/login')}>
              <button className="btn btn_login px-4 py-2" data-cy="login-btn">
                <T>Login</T>
              </button>
          </NavLink>
        </NavItem>
      </RenderIf>
      <RenderIf condition={loggedIn}>
        <NavItem>
          <NavLink href={LL('/dashboard')}>
            <button className="btn btn_white px-4 py-2" data-cy="dashboard-btn">
              <T>Dashboard</T>
            </button>
          </NavLink>
        </NavItem>
      </RenderIf>
    </Nav >
  </>)
}



